import React from 'react';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { LuNotebookPen } from 'react-icons/lu';
import { AppliedCorrectionOut } from '@/client';

/** Machine `kind` values the backend sends — see services/rag/types.py::AppliedCorrection.
 * Anything unrecognized falls back to the raw label so a new kind still renders something. */
const CORRECTION_KIND_LABEL: Record<string, string> = {
	correction: 'Document correction',
	added_fact: 'User-provided fact',
};

interface ChatResponseCorrectionItemProps {
	correction: AppliedCorrectionOut;
}

const ChatResponseCorrectionItem: React.FC<ChatResponseCorrectionItemProps> = (
	props: ChatResponseCorrectionItemProps,
) => {
	const { correction } = props;
	// TODO: Fetch and render the full correction text on demand. AppliedCorrectionOut is deliberately
	// a lightweight reference rather than a verbatim snapshot; the correction read API must also
	// support historical applied refs whose correction has since been deactivated.
	const kindLabel = CORRECTION_KIND_LABEL[correction.kind] ?? correction.label;
	const detail = [correction.subject, correction.applies_to].filter(Boolean).join(' · ') || correction.label;

	return (
		<HStack align="start" gap={2} borderRadius="xl" borderWidth="1px" borderColor="border.subtle" p={3}>
			<Icon as={LuNotebookPen} boxSize={4} color="fg.muted" mt={0.5} flexShrink={0} />
			<VStack align="start" gap={0.5} minW={0} flex={1}>
				<Text textStyle="label" lineClamp={1}>
					{kindLabel}
				</Text>
				<Text fontSize="xs" color="fg.muted" lineClamp={1}>
					{detail}
				</Text>
			</VStack>
		</HStack>
	);
};

export default ChatResponseCorrectionItem;
